import React from 'react';
import { motion } from 'framer-motion';
import { VISUAL_BREAK } from '../lib/data';

const VisualBreak = () => {
  return (
    <section
      className="relative bg-ink text-bone py-0"
      data-testid="visual-break"
    >
      <div className="relative w-full h-[85vh] min-h-[520px] overflow-hidden">
        <motion.img
          src={VISUAL_BREAK.image}
          alt="Installation view"
          initial={{ scale: 1.08 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 2.4, ease: [0.16, 1, 0.3, 1] }}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/25" />
        <div className="absolute inset-0 grain opacity-50" />
      </div>
    </section>
  );
};

export default VisualBreak;
